// extracted by mini-css-extract-plugin
module.exports = {"result-row":"ResultRow_result-row__P2MLB"};